// module
import React from 'react';
import { Link } from 'react-router-dom';

// my components
import DownloadLinks from '../components/DownloadLinks';
import OptionTable from '../components/OptionTable';
import ShowImg from '../components/ShowImg';

// img
import singleDownloadImg from '../img/download_img.png';
import figureImgS7 from '../img/Figure_S7.png';

function Gaap10(){
    window.scrollTo(0,0);
    return(
        <div className="content">
            <h2 className="content_title">Genome annotation</h2>
            <h2 className="content_title2">Functional annotation</h2>
            <div className="content_text">
                Functional annotation is the process of attaching 
                biological information to gene or protein 
                sequences. Functional annotation can be divided 
                into Blast-based homology search and gene ontology-based 
                GO term mapping. GAAP uses Blast2GO.
            </div>
            <h2 className="contnet_description">(1) Homology search</h2>
            <div className="content_text">
                To investigate gene function or predict evolutionary 
                associations between related sequences, newly-assembled 
                sequences are compared with gene sequences with known 
                functions to find sequences with high homology.
            </div>
            <div className="content_command_title">Blast2GO</div><br/>
            <div className="content_text">
                Blast2GO is a pipeline tool that provides local and 
                cloud-based methods of running Blast; these are named 
                LocalBlast and CloudBlast, respectively.
            </div>
            <li className="content_description">Download</li>
            <div className="content_download_box">
                <div className="content_download_img">
                    <img src={singleDownloadImg} alt="error"/>
                </div>
                <div className="content_download_links">
                    <br/><br/>
                    <DownloadLinks link="https://www.blast2go.com" /><br/>
                </div>
            </div><br/>
            <li className="content_description">CloudBlast Command</li>
            <div className="content_text">
                In GAAP, protein sequences obtained from the final 
                results of PASA are used as query sequences, and 
                Blastp is performed using the CloudBlast method 
                provided in Blast2GO.
            </div><br/>
            <li className="content_description">Result of Blastp</li>
            <div className="content_text">
                In the result of Blastp, the meaning of each field is as follows: 
                <ShowImg name="(Supplementary Figure S7)"
                        src= {figureImgS7}
                />.
            </div>
            <OptionTable
                data={[
                    {   option:'SeqName',
                        desc:`the name of the query sequence`},
                    {   option:'description',
                        desc:`description of the mapped sequences`},
                    {   option:'Length',
                        desc:`length of the query sequence`},
                    {   option:'#Hits',
                        desc:`number of sequences mapped to the query sequence`},
                    {   option:'e-value',
                        desc:`significance of the highest ranked mapped sequence`},
                    {   option:'Sim',
                        desc:`mean similarity of the mapped sequences`},
                    {   option:'#GO',
                        desc:`number of mapped terms in GO ontology`},
                    {   option:'GO list',
                        desc:`list of mapped terms in GO ontology`},
                    {   option:'Enzyme list',
                        desc:`list of enzymes searched using GO terms`},
                    {   option:'InterPro Scan',
                        desc:`annotation data for query searched in a protein database`},
                ]}
            /><br />
            <div className="content_buttons_div">
                <Link to="/Gaap09"><button className="content_button">Pre&ensp;</button></Link>
                <Link to="/Gaap11"><button className="content_button">Next</button></Link>
            </div>
        </div>
    );
}

export default Gaap10;